import { create } from 'zustand';

/** P-29 (QX-107): ticket statuses waiting in their 6 s undo window (see `undoableTicketStatus.ts`). */
interface PendingState {
  pending: Record<string, { status: string; token: number }>;
  set: (id: string, status: string, token: number) => void;
  clear: (id: string, token: number) => void;
}
export const usePendingTicketStatus = create<PendingState>((set) => ({
  pending: {},
  set: (id, status, token) => set((s) => ({ pending: { ...s.pending, [id]: { status, token } } })),
  // Only the change that set the value clears it: a newer change on the same ticket keeps its own.
  clear: (id, token) => set((s) => {
    if (s.pending[id]?.token !== token) return s;
    const next = { ...s.pending };
    delete next[id];
    return { pending: next };
  }),
}));
